import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Waterpolo = () => {
  return (
    <SportsLayoutComp name={'Waterpolo'}/>
  )
}

export default Waterpolo